import React from 'react';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

export const SuggestionDeleteButton = ({ onClick }) => {
    return (
        <Button
            onClick={onClick}
            style={{
                padding: '0 8px',
            }}
        >
            <DeleteOutlined />
        </Button>
    );
};
